import { observer } from 'mobx-react-lite'
import { useServiceStore } from '../../ServiceStore'
import Button from '@mui/material/Button'

export default observer(function ServiceActionCancelOrDiscard() {
   const serviceStore = useServiceStore()

   return <>
      {serviceStore.displayCancelOrDiscard && <Button onClick={serviceStore.closeServiceDrawerAndClearForm}>{serviceStore.closeDrawerText}</Button>}
   </>
})
